import React from 'react';
import {useTheme} from '@mui/material';
import type {FilledIconProps} from './types';
import {CheckRoundBackgroundIcon} from './CheckRoundBackgroundIcon';

export const VerifiedIcon: React.FC<FilledIconProps> = ({
  fillColorCode,
  ...props
}) => {
  const {colors} = useTheme();
  return (
    <CheckRoundBackgroundIcon
      fillColorCode={fillColorCode ?? colors.enhancedGreen}
      {...props}
    />
  );
};
